export const UserDefaultConfigConstants = {
    /**
     * User config (set of week holidays)
     */
    WEEK_HOLIDAYS: {
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: true,
        7: true,
    },

    /**
     * * Возможное количество переносов (с 1 до 365), 0: без лимитов
     */
    APPLICATION_MAX_DELAY_DAYS: 0,

    /**
     * 1001:Не удалять, 1002:1 день', 1003:1 неделя, 1004:2 недели, 1005:1 месяц
     */
    NOTIFICATION_DELETE_AFTER_VALUE: '1001',


    // CALENDAR CONFIG

    /**
     * Интервал сетки в минутах, default 30 min
     */
    CALENDAR_SLOT_DURATION: 30,

    /**
     * Время начала рабочего дня default : 09:00
     */
    CALENDAR_SLOT_MIN_TIME: '09:00',

    /**
     * Время завершения рабочего дня default : 18:00
     */
    CALENDAR_SLOT_MAX_TIME: '18:00',


    //ATON CONFIG
    ATON_LOGIN: undefined,
    ATON_PASS: undefined,
    ATON_GROUP: undefined,
    ATON_PATH_TO_2FA: undefined,
    ATON_SHOW_VALUATION: undefined,
}
